import styles from '../Product.module.scss';
import cx from 'classnames';
import { ProductCardSpecificationsWrapperProps } from '../types';

export const ProductCardSpecificationsWrapper = ({
  children,
  className
}: ProductCardSpecificationsWrapperProps) => {
  return (
    <div className="position-relative">
      <div
        className={cx(
          styles['product-comparison__card-specifications'],
          'position-absolute py-3',
          className
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default ProductCardSpecificationsWrapper;
